import { render, staticRenderFns } from "./EditModal.vue?vue&type=template&id=35f04f2e&scoped=true&"
import script from "./EditModal.vue?vue&type=script&lang=ts&"
export * from "./EditModal.vue?vue&type=script&lang=ts&"
import style0 from "./EditModal.vue?vue&type=style&index=0&id=35f04f2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f04f2e",
  null
  
)

export default component.exports